<div id="etrees-counters-live">

  <div *ngIf="authenticationService.userAuthenticated ">
    <p-fieldset [collapsed]="awsService.awsPortalEtreesCountersIsActivated" [toggleable]="true">
      <ng-template pTemplate="header">
        <i [ngClass]="{'text-warnig': !authenticationService.userAuthenticated, 'text-danger': awsService.awsConfigDataReceived && !awsService.awsPortalEtreesCountersIsActivated, 'text-success': awsService.awsConfigDataReceived && awsService.awsPortalEtreesCountersIsActivated}"
           [title]="awsService.awsPortalEtreesCountersIsActivated? 'Activated' : 'Need activation'"
           class="fa fa-circle"
           style="cursor:default"></i>
        Information &nbsp; &nbsp;
        <span *ngIf="!awsService.awsPortalEtreesCountersIsActivated">(Needs activation for live data)</span>
        <span *ngIf="awsService.awsPortalEtreesCountersIsActivated && awsService.loadingStatus">
             ({{ awsService.loadingStatus }})
          </span>
      </ng-template>
      This service allows you to view live values of the <b>E-Trees statistics</b> of McKay in/out devices. <br>
      <i class="fa fa-warning"></i> The information for the MAH-MAP fiber E-trees have the reception and the
      transmission reversed. <br>
      <i class="fa fa-warning"></i> Not all types of counters are available for all BW services. <br>
      <br>
      Please activate (or extend) it for 2 hours: <br>
      <br>
      <span *ngIf="!awsService.awsPortalEtreesCountersIsActivated">
            <p-button (onClick)="onClickActivatePortalPub()"
                      label="Activate Portal Pub/Sub live data access (CrossCo data, E-Tree data, PLR/Lat)"></p-button>
          </span>
      <span *ngIf="awsService.awsPortalEtreesCountersIsActivated">
            <p-button (onClick)="onClickActivatePortalPub()"
                      label="Extend Portal Pub/Sub live data access (CrossCo data, E-Tree data, PLR/Lat)"></p-button>
          </span>
      <span
        *ngIf="awsService.awsPortalEtreesCountersActivationDate"> &nbsp; (Activated: {{ awsService.awsPortalEtreesCountersActivationDate | date:datetimeFormat }}
        &nbsp;({{ awsService.awsPortalEtreesCountersActivationDate | amTimeAgo }}))<br></span>
      <br>
      <br>
      <div class="text-center">
        <!--        <p-lightbox [images]="images"></p-lightbox>-->
      </div>
    </p-fieldset>
    <div *ngIf="listEtreesDropDown.length" class="p-grid">
      <div class="col-12 col-md-9 label-and-control">
        <div class="col-2 label-of-control">
          Filter By E-Tree:
        </div>
        <div class="col-10">
          <p-dropdown (onChange)="onChangeSelectedEtree()" [(ngModel)]="selectedEtreeId" [filter]="true"
                      [options]="listEtreesDropDown" [showClear]="true" placeholder="Choose an E-Tree "></p-dropdown>
        </div>
      </div>
      <div class="col-12 col-md-3 label-and-control">
        <div class="col-5 label-of-control">
          Filter By Crossco:
        </div>
        <div class="col-7">
          <p-dropdown (onChange)="onChangeSelectedCrossco()" [(ngModel)]="selectedCrossco" [filter]="true"
                      [options]="listCrosscoDropDown" [showClear]="true"
                      placeholder="Choose a Crossco "></p-dropdown>
        </div>
      </div>
    </div>

    <div *ngIf="!loadedEtrees">
      Loading E-Trees ... <i class="fa fa-spinner fa-spin"></i>
    </div>

    <span #fieldsetLivePortDataAnchor></span>
    <table *ngIf="etrees && etrees.length" class="table table-striped table-bordered table-sm table-etrees">
      <tr>
        <th class="text-center">E-Tree</th>
        <th class="text-center">Injection</th>
        <th class="text-center">Reception</th>
      </tr>
      <ng-container *ngFor="let etree of etreesToDisplay">
        <tr
          *ngIf="(!selectedEtreeId || selectedEtreeId === etree.id)  && (!selectedCrossco  || etree.crosscosList.includes(selectedCrossco))">
          <td [ngClass]="{'etree-selected': etree.id === selectedEtreeId}" class="col-etree-data" style="width:10%">
            <span class="text-nowrap"><b>{{ etree.contractReference }}</b>&nbsp;<i (click)="onClickSelectEtree(etree.id)"
                                                                                   class="fa fa-filter"></i></span><br>
            <span *ngIf="etree.clientReference">({{ etree.clientReference }})<br></span>
            <span *ngIf="etree.status !== 'accepted'">({{ etree.status }})<br></span>
            <br>
          </td>
          <td *ngIf="!etree._excludedEtreeFiberTemplate" class="td-etrees-injections" style="width:45%">
            <ng-container *ngIf="etree.injection" [ngTemplateOutletContext]="{points:etree.injection, pointType:'injection'}"
                          [ngTemplateOutlet]="points"></ng-container>
          </td>
          <td *ngIf="!etree._excludedEtreeFiberTemplate" style="width:45%">
            <table *ngIf="etree.receptions && etree.receptions.length"
                   class="table table-striped table-bordered table-sm table-etrees-receptions">
              <tr *ngFor="let etreeReception of etree.receptions">
                <td>
                  <ng-container [ngTemplateOutletContext]="{points:etreeReception, pointType:'reception', etreeId:etree.id}"
                                [ngTemplateOutlet]="points"></ng-container>
                </td>
              </tr>
            </table>
          </td>
          <td *ngIf="etree._excludedEtreeFiberTemplate" class="text-center text-warning" colspan="2" style="width:90%">
            <br>
            <i class="fa fa-warning"></i>&nbsp;This type of E-Tree does not have counters associated. <br>
            <br>
          </td>
        </tr>
      </ng-container>
    </table>
    <br>
    <div class="bg-light text-primary p-2">
      <i class="fa fa-info-circle"></i>&nbsp;<b>CrossCo counters</b> are related to the first/last ports in McKay's
      network, and may be shared by more than one E-Tree<br>
      <i class="fa fa-info-circle"></i>&nbsp;<b>E-Trees counters</b> are related to a single E-Tree and provides
      additional counters specific to that E-Tree<br>
      <i class="fa fa-info-circle"></i>&nbsp;<b>The error 'Data not provided yet'</b> may by associated with some output
      E-Tree counters: it indicates that no specific E-Trees counters are
      available currently.<br>
      <i class="fa fa-info-circle"></i>&nbsp;<b>PLR and latency</b> provided on each endpoint are related to Mckay
      monitoring system and may slightly differ from Client's real values<br>
      <i class="fa fa-info-circle"></i>&nbsp;<b>MQTT json counters keys</b> are provided when passing the mouse on
      CrossCo/E-Trees headers<br>
      <i class="fa fa-info-circle"></i>&nbsp;<b>MQTT fields codes</b> are provided when passing the mouse on counters
      names<br>
    </div>


    <ng-template #points let-etreeId='etreeId' let-pointType='pointType' let-points='points'>
      <div class="p-grid">
        <div class="col-1">
          <b *ngIf="points.pop">[{{ points.pop }}]</b>
        </div>
        <div class="col-11">
          <table class="table table-striped table-sm table-points">
            <tr *ngFor="let ccp of points.ccps">
              <td>
                <!--                {{ccp|json}} <br>-->
                <div [ngClass]="{'crossco-selected': ccp.crossco === selectedCrossco}" style="padding:5px">
                  <b>
                    {{ ccp.type }} -
                    {{ ccp.crossco }}
                    <i (click)="onClickSelectCrossCo(ccp.crossco)" class="fa fa-filter"></i>
                    {{ ccp.vlan ? ' - vlan:' + ccp.vlan : '' }}
                    {{ ccp.hk ? ' - HK:' + ccp.hk : '' }}
                    <span
                      *ngIf="pointType==='reception' && (ccp.injectionMethod === 'MBEL' || ccp.injectionMethod==='LCM')">(from {{ ccp.injectionMethod }}
                      )</span>
                  </b>
                </div>

                <div *ngIf="ccp.type === 'Listen/Reinject'" class="text-warning">
                  <i class="fa fa-warning"></i>&nbsp;This type of CCP does not have counters associated. <br>
                </div>

                <div *ngIf="ccp.type!='Listen/Reinject' && pointType==='reception' && awsService.plrLatData.lastLoadedData && awsService.plrLatData.lastLoadedData[etreeId] && awsService.plrLatData.lastLoadedData[etreeId][ccp.key2]  as plrLatData "
                     class="col-counters text-center">
                  <table class="table table-striped table-bordered table-sm table-counters table-counters-plrlat">
                    <tr>
                      <td style="width:30%">
                        McKay monitoring <i class="fa fa-info-circle"
                                            pTooltip="PLR and latency provided on each endpoint are related to Mckay monitoring system and may slightly differ from Client's real values"
                                            tooltipPosition="bottom"></i>:
                      </td>
                      <td style="width:25%">
                        PLR: <b>{{ plrLatData.plr }} %</b> &nbsp;
                        <button (click)="selectGraphOverlay($event, 'plrLatData', etreeId + '_' + ccp.key2, 'plr', overlayPanelGraph)" class="p-button-secondary btn-graph" icon="pi pi-search" pButton
                                type="button"></button>
                      </td>
                      <td style="width:45%">
                        Latency: <b>{{ plrLatData.lat | number }} ns</b> &nbsp;
                        <button (click)="selectGraphOverlay($event, 'plrLatData', etreeId + '_' + ccp.key2, 'lat', overlayPanelGraph)" class="p-button-secondary btn-graph" icon="pi pi-search" pButton
                                type="button"></button>
                      </td>
                    </tr>
                    <td class="row-time" colspan="3">
                      <span>&#64; {{ plrLatData.time | date:datetimeFormat }} &nbsp;({{ plrLatData.time | amTimeAgo }}
                        )</span>
                      <!--                      {{ccp.key2}} ###-->
                    </td>
                  </table>
                </div>

                <div *ngIf="ccp.type!='Listen/Reinject'" class="col-counters text-center">
                  <table class="table table-striped table-bordered table-sm table-counters table-counters-crossco">
                    <tr class="cursor-pointer">
                      <td (click)="ccp.crosscoDataOpened = !ccp.crosscoDataOpened" [title]="'Port counters for key: '+ ccp.key" class="text-center"
                          colspan="3"
                          style="cursor:pointer">
                        <!--                          [title]="'Port counters for key: '+ ccp.key + '  |  ' + ccp.keyFull">-->
                        <i class="fa fa-plug"></i> Crossco counters&nbsp;
                        <!--                        {{ccp.key}} ###-->
                        <i [ngClass]="{'fa-minus': ccp.crosscoDataOpened, 'fa-plus': !ccp.crosscoDataOpened }"
                           class="fa"></i>
                      </td>
                    </tr>

                    <ng-container
                      *ngIf="ccp.crosscoDataOpened && (!awsService.crosscosData.lastLoadedData || !awsService.crosscosData.lastLoadedData[ccp.key]) as countersData">
                      <tr>
                        <td class="text-center">No CrossoCo counters data data yet..</td>
                      </tr>
                    </ng-container>

                    <ng-container
                      *ngIf="ccp.crosscoDataOpened && awsService.crosscosData.lastLoadedData && awsService.crosscosData.lastLoadedData[ccp.key] as countersData">
                      <tr *ngIf="isDefinedVar(countersData['rx_pow'])" class="counter-physical-status">
                        <td title="rx_pow">Rx Power (dBm):</td>
                        <td><b>{{ countersData['rx_pow'] }}</b></td>
                        <td>
                          <button (click)="selectGraphOverlay($event, 'crosscosData', ccp.key, 'rx_pow', overlayPanelGraph)" class="p-button-secondary btn-graph" icon="pi pi-search"
                                  pButton
                                  type="button"></button>
                        </td>
                      </tr>
                      <tr *ngIf="isDefinedVar(countersData['tx_pow'])" class="counter-physical-status">
                        <td title="tx_pow">Tx Power (dBm):</td>
                        <td><b>{{ countersData['tx_pow'] }}</b></td>
                        <td>
                          <button (click)="selectGraphOverlay($event, 'crosscosData', ccp.key, 'tx_pow', overlayPanelGraph)" class="p-button-secondary btn-graph" icon="pi pi-search"
                                  pButton
                                  type="button"></button>
                        </td>
                      </tr>
                      <tr *ngIf="isDefinedVar(countersData['sp'])" class="counter-physical-status">
                        <td title="sp">Speed (Gbps):</td>
                        <td><b>{{ countersData['sp'] }}</b></td>
                        <td>
                          <button (click)="selectGraphOverlay($event, 'crosscosData', ccp.key, 'sp', overlayPanelGraph)" class="p-button-secondary btn-graph" icon="pi pi-search"
                                  pButton
                                  type="button"></button>
                        </td>
                      </tr>
                      <tr *ngIf="isDefinedVar(countersData['sfp_t'])" class="row-time counter-physical-status">
                        <td colspan="3">
                          <span title="sfp_t">&#64; {{ countersData['sfp_t'] | date:datetimeFormat }}
                            &nbsp;({{ countersData['sfp_t'] | amTimeAgo }})</span>
                        </td>
                      </tr>
                      <tr *ngIf="isDefinedVar(countersData['i_st'])" class="">
                        <td title="i_st">Interface Status:</td>
                        <td><b>{{ countersData['i_st'] }}</b></td>
                        <td>
                          <button (click)="selectGraphOverlay($event, 'crosscosData', ccp.key, 'i_st', overlayPanelGraph)" class="p-button-secondary btn-graph" icon="pi pi-search"
                                  pButton
                                  type="button"></button>
                        </td>
                      </tr>

                      <ng-container *ngFor="let portCounterField of awsService.portsCountersGenericFields">
                        <tr *ngIf="isDefinedVar(countersData[portCounterField['code']])
                                                && (pointType==='injection' && portCounterField['type']==='rx' || pointType==='reception' && portCounterField['type']==='tx')"
                            class="counter-{{portCounterField['type']}}">
                          <td [title]="portCounterField['code']">{{ portCounterField['label'] }}:</td>
                          <td><b>{{ countersData[portCounterField['code']] | number }}</b></td>
                          <td>
                            <button (click)="selectGraphOverlay($event, 'crosscosData', ccp.key, portCounterField['code'], overlayPanelGraph)" class="p-button-secondary btn-graph" icon="pi pi-search" pButton
                                    type="button"></button>
                          </td>
                        </tr>
                      </ng-container>

                      <tr *ngIf="isDefinedVar(countersData['t'])" class="row-time">
                        <td colspan="3">
                          <span title="t">&#64; {{ countersData['t'] | date:datetimeFormat }}
                            &nbsp;({{ countersData['t'] | amTimeAgo }})</span>
                        </td>
                      </tr>
                      <tr *ngIf="!isDefinedVar(countersData['t'])" class="row-error">
                        <td colspan="3">
                          <span>No Counters Data received </span>
                          <i class="fa fa-info-circle"
                             pTooltip="We do not fully cover our network's counters yet. They will be added as soon as possible"
                             tooltipPosition="bottom"></i>
                        </td>
                      </tr>
                      <tr *ngIf="isDefinedVar(countersData['error'])" class="row-error">
                        <td colspan="3">
                          Error: <span>{{ countersData['error'] }} </span>
                          <i class="fa fa-info-circle"
                             pTooltip="We do not fully cover our network's counters yet. They will be added as soon as possible"
                             tooltipPosition="bottom"></i>
                        </td>
                      </tr>
                      <tr *ngIf="warningEndpointsEtreesByKeys[pointType][ccp.key] && warningEndpointsEtreesByKeys[pointType][ccp.key].length >=2
                              && warningEndpointsEtreesByKeys[pointType][ccp.key] as endpointsEtreesByThisKey">
                        <td class="bg-warning-counters cursor-pointer" colspan="3">
                          <div (click)="ccp.warningsCrosscoOpened = !ccp.warningsCrosscoOpened" class="text-center">
                            <i class="fa fa-warning"></i> There
                            are {{ warningEndpointsEtreesByKeys[pointType][ccp.key].length }} E-Trees sharing for this
                            CrossCo/strand {{ pointType }}:
                            <i *ngIf="!ccp.warningsCrosscoOpened" class="fa fa-minus"></i>
                            <i *ngIf="!!ccp.warningsCrosscoOpened" class="fa fa-plus"></i>
                          </div>
                          <div *ngIf="ccp.warningsCrosscoOpened">
                            <div *ngFor="let etreeDuplicatedId of endpointsEtreesByThisKey">
                              <i class="fa fa-circle"></i> {{ etreesByIds[etreeDuplicatedId]?.etreeShortName }}
                              &nbsp;<i (click)="onClickSelectEtree(etreeDuplicatedId)" *ngIf="etreeId!==etreeDuplicatedId"
                                       class="fa fa-filter" title="Filter"></i>
                              &nbsp;<i (click)="onClickSelectEtree(etreeDuplicatedId)" *ngIf="etreeId===etreeDuplicatedId"
                                       class="fa fa-arrow-left" title="Filter"></i>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                  </table>
                </div>

                <div *ngIf="ccp.type === 'TBV'" class="text-warning">
                  <i class="fa fa-warning"></i>&nbsp;This type of CCP does not have E-Tree counters associated. <br>
                </div>

                <div *ngIf="ccp.type!=='TBV' && ccp.type!='Listen/Reinject'" class="col-etrees text-center">
                  <table class="table table-striped table-bordered table-sm table-counters table-counters-etree">
                    <tr (click)="ccp.countersEtreeClosed = !ccp.countersEtreeClosed" class="cursor-pointer">
                      <!--                                            <td colspan="3" class="text-center" [title]="'E-Tree counters for key3: '+ ccp.key3 + '  |  ' + ccp.key3Full">-->
                      <td [title]="'E-Tree counters for key3: '+ ccp.key3" class="text-center" colspan="3">
                        <i class="fa fa-sitemap"></i> E-Tree counters&nbsp;
                        <!--                        {{ccp.key3}} ###-->
                        <i [ngClass]="{'fa-plus': ccp.countersEtreeClosed, 'fa-minus': !ccp.countersEtreeClosed }"
                           class="fa"></i>
                      </td>
                    </tr>

                    <ng-container
                      *ngIf="!ccp.countersEtreeClosed && (!awsService.etreesData.lastLoadedData || !awsService.etreesData.lastLoadedData[ccp.key3])">
                      <tr>
                        <td class="text-center">No E-Tree counters data yet... there might be no available data for this
                          E-tree at the moment
                        </td>
                      </tr>
                    </ng-container>
                    <ng-container
                      *ngIf="!ccp.countersEtreeClosed && awsService.etreesData.lastLoadedData && awsService.etreesData.lastLoadedData[ccp.key3] as countersData">

                      <ng-container *ngFor="let etreeCounterField of awsService.etreesCountersGenericFields">
                        <tr *ngIf="isDefinedVar(countersData[etreeCounterField['code']])
                                                && (pointType==='injection' && etreeCounterField['type']==='rx' || pointType==='reception' && etreeCounterField['type']==='tx')"
                            class="counter-{{etreeCounterField['type']}}">
                          <td [title]="etreeCounterField['code']">{{ etreeCounterField['label'] }}:</td>
                          <td><b>{{ countersData[etreeCounterField['code']] | number }}</b></td>
                          <td>
                            <button (click)="selectGraphOverlay($event, 'etreesData', ccp.key3, etreeCounterField['code'], overlayPanelGraph)" class="p-button-secondary btn-graph" icon="pi pi-search" pButton
                                    type="button"></button>
                          </td>
                        </tr>
                      </ng-container>

                      <tr *ngIf="isDefinedVar(countersData['t'])" class="row-time">
                        <td colspan="3">
                          <span title="t">&#64; {{ countersData['t'] | date:datetimeFormat }}
                            &nbsp;({{ countersData['t'] | amTimeAgo }})</span>
                        </td>
                      </tr>
                      <tr *ngIf="!isDefinedVar(countersData['t'])" class="row-error">
                        <td colspan="3">
                          <span>No Counters Data received </span>
                          <i class="fa fa-info-circle"
                             pTooltip="We do not fully cover our network's counters yet. They will be added as soon as possible"
                             tooltipPosition="bottom"></i>
                        </td>
                      </tr>
                      <tr *ngIf="isDefinedVar(countersData['error'])" class="row-error">
                        <td colspan="3">
                          Error: <span>{{ countersData['error'] }} </span>
                          <i class="fa fa-info-circle"
                             pTooltip="We do not fully cover our network's counters yet. They will be added as soon as possible"
                             tooltipPosition="bottom"></i>
                        </td>
                      </tr>
                      <tr
                        *ngIf="warningMonitoringDevicesEtreesByKeys[pointType][ccp.key3] && warningMonitoringDevicesEtreesByKeys[pointType][ccp.key3].length>=2 && warningMonitoringDevicesEtreesByKeys[pointType][ccp.key3]  as endpointsEtreesByThisKey">
                        <td colspan="3">
                          <div (click)="ccp.warningsEtreesOpened = ! ccp.warningsEtreesOpened" style="cursor:pointer">
                            <i class="fa fa-warning"></i> There
                            are {{ warningMonitoringDevicesEtreesByKeys[pointType][ccp.key3].length }} E-Trees sharing
                            for this E-Tree data in {{ pointType }}:
                            <i *ngIf="!ccp.warningsEtreesOpened" class="fa fa-minus"></i>
                            <i *ngIf="!!ccp.warningsEtreesOpened" class="fa fa-plus"></i>
                          </div>
                          <div *ngIf="ccp.warningsEtreesOpened">
                            <div *ngFor="let etreeDuplicatedId of endpointsEtreesByThisKey">
                              <i class="fa fa-circle-o"></i> {{ etreesByIds[etreeDuplicatedId].etreeShortName }}
                              &nbsp;<i (click)="onClickSelectEtree(etreeDuplicatedId)" *ngIf="etreeId!==etreeDuplicatedId"
                                       class="fa fa-filter" title="Filter"></i>
                              &nbsp;<i (click)="onClickSelectEtree(etreeDuplicatedId)" *ngIf="etreeId===etreeDuplicatedId"
                                       class="fa fa-arrow-left" title="Filter"></i>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                  </table>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </ng-template>

  </div>

  <br><br>


  <p-overlayPanel #overlayPanelGraph class="overlayPanelGraph">
    <div class="graph-title">
      <b>History of {{ awsService.fieldsNameForRawValueInHistory.includes(selectedGraphField) ? '' : 'variations of ' }}
        values for field '{{ selectedGraphField }}'</b>&nbsp;
      <span *ngIf="selectedGraphData && selectedGraphData.datasets"> ({{ selectedGraphData.datasets[0].data.length }}
        value{{ selectedGraphData.datasets[0].data.length > 1 ? 's' : '' }})</span>
      <span *ngIf="!selectedGraphData || !selectedGraphData.datasets"> (No values yet)</span>
    </div>
    <div>
      <p-chart #chartValuesHistory [data]="selectedGraphData" [options]="awsService.graphsOptions" [responsive]="false"
               height="400px" type="line" width="600px"></p-chart>
    </div>
    <div class="text-center"><small>(The values shown in the graphs are stored in your browser. Please do wait a few
      minutes to start seeing a graph.)</small></div>
  </p-overlayPanel>


</div>
